import {
    INVALIDATE_PROMOCIONES,
    REQUEST_PROMOCIONES, RECEIVE_PROMOCIONES, ERROR_PROMOCIONES
} from '../actions/PromocionesActions';
import { combineReducers } from 'redux';
import normalizeDatos from "../normalizers/normalizePromociones";

function promocionesById(state = {
    isFetching: false,
    didInvalidate: true,
    promociones: []
}, action) {
    switch (action.type) {
        case INVALIDATE_PROMOCIONES:
            return Object.assign({}, state, {
                didInvalidate: true
            });
        case REQUEST_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case RECEIVE_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                promociones: action.promociones.entities.promociones,
                lastUpdated: action.receivedAt
            });
        case ERROR_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: true,
                error: action.error
            });
        default:
            return state
    }
}


function allPromociones(state = [], action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return action.promociones.result;
        default:
            return state
    }
}


const promociones = combineReducers({
    byId : promocionesById,
    allIds : allPromociones
});

export default promociones;


// WEBPACK FOOTER //
// ./src/reducers/promociones.js